<template>
  <div :class="$style.root">
    <div :class="$style.labelContainer">
      <div :class="$style.label">{{ $t('pages.press.entries.label') }}</div>
    </div>

    <ul :class="$style.list">
      <li
        v-for="entry in data"
        :key="entry?.id"
        :class="$style.item"
      >
        <SharedPressEntriesThumbnailComponent :data="entry" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps({
  data: {
    type: Array,
    required: true
  }
})
</script>

<style module lang="scss">
.root {
  padding: 0 var(--unit--default);
}

.labelContainer {
  composes: font-helvetica font-size-small from global;
  margin-bottom: var(--lh, 1em);
}

.label {
}

.list {
  composes: reset-list from global;

  columns: 3;
  column-gap: calc(var(--unit--default) * 2);

  @media (max-width: $breakpoint-m) {
    columns: 2;
  }

  @media (max-width: $breakpoint-s) {
    columns: 1;
  }
}

.item {
  border-top: var(--stroke--default) solid;
  border-bottom: var(--stroke--default) solid;
  margin-bottom: calc(var(--stroke--default) * -1);

  padding-top: calc(var(--unit--default) / 2);
  padding-bottom: calc(var(--unit--default) / 2);

  break-inside: avoid;
}

.item:last-of-type {
  border-bottom: var(--stroke--default) solid;
}
</style>
